module.exports = __webpack_public_path__ + "img/3-4-2.7ffc2d9d.png";